<template>
  <div id="apps">
    <Header></Header>
    <transition name="slide">
      <router-view></router-view>
    </transition>
    <Footer></Footer>
    <div class="sideTools">
      <side-tools></side-tools>
    </div>
  </div>
</template>
<script>
// var _hmt = _hmt || [];
// (function() {
//   var hm = document.createElement("script");
//   hm.src = "https://hm.baidu.com/hm.js?b6c638d05345924305b11c536f87b4f4";
//   var s = document.getElementsByTagName("script")[0];
//   s.parentNode.insertBefore(hm, s);
//   window._hmt = _hmt;
// })();
var _hmt = _hmt || [];
(function () {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?93eb4c68f84adf0ac07da9243f58f4d6";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
  window._hmt = _hmt;
})();

import Header from "./components/Header";
import Footer from "./components/Footer";
import SideTools from "./components/sideTools";
export default {
  name: "App",
  components: {
    Header,
    Footer,
    SideTools,
  },
  data: () => ({
    //
  }),
  watch: {
    $route: {
      handler() {
        window.scrollTo(0, 0);
        document.getElementById("apps").scrollTop = 0;
      },
      deep: true,
    },
  },
  mounted() {
    // console.log(this.$router.push("home"));
  },
};
</script>
<style lang="scss" scoped>
@import "./pages/base.scss";
.sideTools {
  position: fixed;
  bottom: vh(180px);
  right: vw(20px);
  width: 40px;
  height: vh(160px);
  z-index: 10;
}
</style>
<style>
html,
body {
  margin: 0;
  padding: 0;
  overflow: hidden !important;
}
body {
  width: 100%;
  height: 100%;
}
body > div {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
}
a {
  text-decoration: none;
}
</style>
